import { Button, Menu, MenuButton, MenuList, Portal, useDisclosure } from '@chakra-ui/react';

import { ChevronDown, HasAccess } from '@enterprise/ui';

import type { AdminMenuProps } from './types/admin-menu.props';

import NavMenuItem from './nav-menu-item';

const AdminMenu = ({ isActive }: AdminMenuProps) => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <Menu
      gutter={0}
      isLazy
      isOpen={isOpen}
      placement="bottom-end">
      <MenuButton
        _expanded={
          isActive ? { bg: 'hsp.500', color: 'white' } : { boxShadow: '0 0 0 3px var(--chakra-colors-hsp-200)' }
        }
        _focus={{ boxShadow: '0 0 0 3px var(--chakra-colors-hsp-200)' }}
        _hover={isActive ? { bg: 'hsp.600' } : { bg: 'hsp.100', boxShadow: '0 0 0 3px var(--chakra-colors-hsp-200)' }}
        as={Button}
        bg={isActive ? 'hsp.500' : 'transparent'}
        borderColor="transparent"
        borderRadius="md"
        borderWidth="1px"
        color={isActive ? 'white' : 'hsp.500'}
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
        p={2}
        rightIcon={<ChevronDown className="ms-1" />}
        rounded="lg">
        Admin
      </MenuButton>
      <Portal>
        <MenuList
          borderColor="hsp.500"
          onMouseEnter={onOpen}
          onMouseLeave={onClose}>
          <HasAccess permissions={['view-users']}>
            <NavMenuItem to="/datastream/admin/usermanagement">User Management</NavMenuItem>
          </HasAccess>
        </MenuList>
      </Portal>
    </Menu>
  );
};

export default AdminMenu;
